// extracted by mini-css-extract-plugin
export var changeIcon = "_4b-4";
export var clickable = "_4b-8";
export var container = "_4b-0";
export var divider = "_4b-7";
export var externalLinkIcon = "_4b-1";
export var green = "_4b-5";
export var helpCircleIcon = "_4b-3";
export var iconButton = "_4b-2";
export var red = "_4b-6";